export default "__VITE_ASSET__P7ITL4KG__"